module.exports = __webpack_public_path__ + "img/website.6d6cb012.jpg";